import i18next from 'i18next'

export function generateFilterOptions(
  items = [],
  selectedItems = [],
  isAllSelected = false
) {
  return items.map((item) => ({
    label: i18next.t(`options.${item?.['name-token']}`),
    value: item?.id,
    isSelected: isAllSelected || selectedItems.includes(item?.id)
  }))
}

export function isAtLeastOneFilterSelected(filters = [[], []]) {
  return filters.some((filter) => filter.length > 0)
}
